import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const upload = async (file: FormData) => {
  const res = await httpRequest.upload('/api/media/upload', file);
  return res;
};
